import { countReaction } from '../lib/puns';
import { useTopPuns } from '../lib/useTopPuns';

/** How many make the panel. Three fills the column beside the form without scrolling. */
const SHOWN = 3;

/**
 * The proof, next to the sign-up form.
 *
 * Both signed-out screens get it. It lived inside `Login` and so was missing
 * from `Signup` — which is backwards: the person being asked to make an account
 * is exactly the one who has not yet seen a reason to.
 *
 * Deliberately not `PunCard`: that one carries reactions, crown budget and an
 * author link, all of which need a signed-in viewer. This is a flat quote.
 */
function TopPuns() {
  const puns = useTopPuns(SHOWN);

  // Nothing rather than an empty frame. On a brand-new project, or if the read
  // fails, the auth screen should look like it was designed without a sidebar.
  if (puns.length === 0) return null;

  return (
    <section>
      <h2 className="mb-4 font-display text-lg font-bold">Best of the week</h2>
      <div className="space-y-4">
        {puns.map((pun) => (
          <article
            key={pun.id}
            className="rounded-2xl border-2 border-ink bg-white px-5 py-4 shadow-pop"
          >
            <p className="font-display text-lg font-bold leading-snug">{pun.text}</p>
            <p className="mt-2 flex items-center justify-between text-xs text-ink/45">
              <span>
                {pun.output} &middot; {pun.category}
              </span>
              <span className="font-bold tabular-nums">
                {countReaction(pun, 'crown')} <span aria-hidden="true">&#128081;</span>
              </span>
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default TopPuns;
